<template>
  <SiteLayout>
    <p>Content goes here</p>
  </SiteLayout>
</template>

<script>
import { computed, reactive } from 'vue'
import {useHead } from '@vueuse/head'
import SiteLayout from '@/components/layout/SiteLayout.vue'
export default {
  name: 'App',
  components: {
    SiteLayout
  },
  setup() {
    const siteData = reactive({
      title: `APCOA - ticket portal`,
      description: `APCOA Ticketportal für Parkverstöße`, 
      keywords: `keywords`
    })
    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          meta:`description`,
          content: computed(() => siteData.description),
        },
        {
          meta:`keywords`,
          content: computed(() => siteData.keywords),
        }
      ],
      htmlAttrs: {
        lang: "de-DE",
      },
    })
  }
}
</script>